<template>
  <ion-page mode="ios">
    <!-- Header Section (Blue) -->
    <ion-header mode="ios" class="header-blue">
      <div class="header-content ">
        <div style="margin-top: 75px;" class="header-search">
          <ion-searchbar
            placeholder="Belajar Apa Hari ini?"
            class="search-bar"
          ></ion-searchbar>
          <ion-button class="notification-button">
            <img
              style="width: 40px; height: 30px"
              src="../assets/Alarm.png"
              alt=""
            />
          </ion-button>
        </div>
      </div>
    </ion-header>
    <!-- Main Content Section (White) -->
    <ion-content class="home-page">
      <!-- Pesan Status Non-aktif -->
    <center>
 
      <div v-if="!isUserActive" class="status-warning">
          <ion-label class="warning-text">
              Status Anda non-aktif, silakan hubungi admin.
          </ion-label>
          </div>
    </center>
      <ion-refresher slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content />
      </ion-refresher>
      <ion-content class="ion-padding">
        <h1 class="header-title">Halo {{ fullName }}</h1>
        <div class="class-info">
          <ion-label class="class-label">Kelas :</ion-label>
          <ion-button class="kelas-button">{{ userClass }}</ion-button>
        </div>
        <ion-badge style="color: #fbbf24; margin-top: 12px; margin-left: 15px">
          Paket Belajar Juara Kelas!
        </ion-badge>
        <br />
        <center>
          <ion-badge class="custom-badge">
            <div class="badge-item">
              <img class="icon" src="../assets/medal.png" alt="Medal" />
              <h1 class="badge-text">{{ medalCount }} Medal</h1>
            </div>
            <div class="badge-item">
              <img class="icon" src="../assets/hat.png" alt="Hat" />
              <h1 class="badge-text">Peringkat ke {{ ranking }}</h1>
            </div>
          </ion-badge>
        </center>

        
         <!-- Fitur -->
   <ion-card style="border-radius: 12px;">
        <ion-card-content>
          <div class="features-container">
            <div class="features-grid">
              <div class="feature-item">
                <div class="icon-wrapper">
                  <img @click="goToRaportPage" src="../assets/raport.svg" style="width: 40px; height: 40px;" alt="">
                </div>
                <p>Raport Penilaian</p>
              </div>
              <!-- <div class="feature-item">
                <div class="icon-wrapper">
                  <img @click="goToEbookPage" src="../assets/ebook.svg" style="width: 40px; height: 40px;" alt="">
                </div>
                <p>E-book</p>
              </div> -->
              <!-- <div class="feature-item">
                <div class="icon-wrapper">
                  <img @click="goToGamesPage" src="../assets/game.svg" style="width: 40px; height: 40px;" alt="">
                </div>
                <p>Belajar dan Bermain</p>
              </div> -->
              <!-- <div class="feature-item">
                <div class="icon-wrapper">
                  <img  @click="goToRefrensiPage" src="../assets/more.svg" style="width: 40px; height: 40px;" alt="">
                </div>
                <p>More</p>
              </div> -->
            </div>
          </div>
        </ion-card-content>
      </ion-card> 
      <!-- Fitur -->



          <!-- Dinamis Ion Card -->
              <!-- <ion-card style="background-color: #faf8f2" :disabled="!isUserActive">
                <div class="image-grid" v-if="!loading">
                  <div v-for="item in mataPelajaran" :key="item.id">
                  <img
                    class="card-image"
                    :src="item.imageUrl"
                    :alt="item.name"
                    @click="navigateToMateri(item)"
                  />
                  <ion-label class="labell">{{ item.name }}</ion-label>
                  <ion-spinner v-if="loading" name="crescent"></ion-spinner>
                </div>
              </div>
            </ion-card> -->
        <!-- Dinamis Ion Card -->

        
           <!-- SNBT -->
           <img
          v-if="userClass === 'KELAS 12 SNBT'"
          style="width: 207px; margin-bottom: -5px; margin-top: 20px"
          src="../gama/SNBT.png"
          alt=""
        />
        <ion-card
          style="background-color: #f0f4fa; margin-top: 10px;"
          :disabled="!isUserActive"
          v-if="userClass === 'KELAS 12 SNBT' && daftarUjiansnbt.filter(ujian => ujian.aktif === true).length > 0"
        >
          <div v-if="daftarUjiansnbt.length">
            <ion-grid>
              <ion-row>
                <!-- Tampilkan 3 data pertama -->
                <ion-col
                    size="6"
                    v-for="ujian in daftarUjiansnbt.filter(ujian => ujian.aktif === true)"
                    :key="ujian.id"
                    @click="navigateToDetailUjiansnbt(ujian.id)"
                    style="cursor: pointer;"
                  >
                  <div style="border: 1px solid #ddd; padding: 15px; border-radius: 8px; background-color: #8e44ad; margin: 5px; display: flex; flex-direction: column; align-items: center; justify-content: space-between; height: 150px;">
                    <p style="text-align: center; font-size: 16px; font-weight: bold; color: #fff; flex: 1; display: flex; align-items: center; justify-content: center;">{{ ujian.judulUjian }}</p>
                    <button style="background-color: #4CAF50; color: white; border: none; padding: 10px 20px; font-size: 14px; border-radius: 5px; cursor: pointer;">
                      Mulai
                    </button>
                  </div>
                </ion-col>

                <!-- Item ke-4 sebagai "Lihat Lebih Banyak" -->
                <ion-col size="6" v-if="daftarUjiansnbt.length > 3" @click="navigateToAllUjiansnbt" style="cursor: pointer;">
                  <div style="border: 1px solid #ddd; padding: 15px; border-radius: 8px; background-color: #8e44ad; margin: 5px; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 150px;">
                    <p style="text-align: center; font-size: 16px; font-weight: bold; color: #fff;">
                      Lihat lebih banyak
                    </p>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
          <ion-spinner v-else name="crescent" style="margin: 20px auto; display: block;"></ion-spinner>
        </ion-card>
        <!-- SNBT -->

        <!-- Kedinasan -->
        <img
        v-if="userClass === 'KELAS 12 KEDINASAN'"
          style="width: 207px; margin-bottom: 10px"
          src="../gama/dinas.png"
          alt=""
        />
        <ion-card style="background-color: #f0f4fa; margin-top: 10px;" :disabled="!isUserActive" v-if="userClass === 'KELAS 12 KEDINASAN'">
          <div v-if="daftarUjian.length">
            <ion-grid>
              <ion-row>
                <ion-col size="6" v-for="ujian in daftarUjian" :key="ujian.id" @click="navigateToDetailUjian(ujian.id)" style="cursor: pointer;">
                  <div style="border: 1px solid #ddd; padding: 15px; border-radius: 8px; background-color: #3B73C5; margin: 5px; display: flex; flex-direction: column; align-items: center; justify-content: space-between; height: 150px;">
                    <p style="text-align: center; font-size: 16px; font-weight: bold; color: #fff; flex: 1; display: flex; align-items: center; justify-content: center;">{{ ujian.judulUjian }}</p>
                    
                    <!-- Tombol Mulai -->
                    <button style="background-color: #4CAF50; color: white; border: none; padding: 10px 20px; font-size: 14px; border-radius: 5px; cursor: pointer;">
                      Mulai
                    </button>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
          <ion-spinner v-else name="crescent" style="margin: 20px auto; display: block;"></ion-spinner>
        </ion-card>
        <!-- Kedinasan -->

       <!-- Ujian Reguler -->
              <ion-card style="background-color: #f0f4fa; margin-top: 10px;" 
                        :disabled="!isUserActive" 
                        v-if="ujianReguler.length">
                <div>
                  <ion-grid>
                    <ion-row>
                      <ion-col size="6" 
                              v-for="ujian in ujianReguler" 
                              :key="ujian.id" 
                              @click="navigateToDetailUjianReguler(ujian.id)" 
                              style="cursor: pointer;">
                        <div style="border: 1px solid #ddd; 
                                    padding: 15px; 
                                    border-radius: 8px; 
                                    background-color: #3B73C5; 
                                    margin: 5px; 
                                    display: flex; 
                                    flex-direction: column; 
                                    align-items: center; 
                                    justify-content: space-between; 
                                    height: 150px;">
                          
                          <!-- Judul Ujian -->
                          <p style="text-align: center; 
                                    font-size: 16px; 
                                    font-weight: bold; 
                                    color: #fff; 
                                    flex: 1; 
                                    display: flex; 
                                    align-items: center; 
                                    justify-content: center;">
                            {{ ujian.judul }}
                          </p>
                          
                          <!-- Tombol Mulai -->
                          <button style="background-color: #4CAF50; 
                                        color: white; 
                                        border: none; 
                                        padding: 10px 20px; 
                                        font-size: 14px; 
                                        border-radius: 5px; 
                                        cursor: pointer;">
                            Mulai
                          </button>
                        </div>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </div>
              </ion-card>

              <!-- Spinner jika loading -->
              <ion-spinner v-else 
                          name="crescent" 
                          style="margin: 20px auto; display: block;">
              </ion-spinner>

        <img
          style="width: 207px; margin-bottom: 10px"
          src="../gama/seru.png"
          alt=""
        />

        <!-- Menu Game Grid (2x2) -->
        <ion-grid style="padding: 0 5px; margin-bottom: 20px;">
          <ion-row>
            <!-- Game 1: Pengetahuan Dasar (Gabungan Math & Bahasa) -->
            <ion-col size="6">
              <ion-card @click="goToGame('dasar')" style="cursor: pointer; height: 100%; border-radius: 12px; background: linear-gradient(135deg, #FF9A9E 0%, #FECFEF 100%); margin: 0; box-shadow: 0 4px 8px rgba(0,0,0,0.15);">
                <ion-card-content style="text-align: center; color: #fff; padding: 20px 5px; display: flex; flex-direction: column; justify-content: center; height: 100%;">
                  <h2 style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: white;">🧠 Pengetahuan Dasar</h2>
                  <p style="font-size: 11px; margin: 0; line-height: 1.2; color: white;">Asah otak mudah</p>
                </ion-card-content>
              </ion-card>
            </ion-col>
            
            <!-- Game 2: Teka Teki Silang -->
            <ion-col size="6">
              <ion-card @click="goToGame('tts')" style="cursor: pointer; height: 100%; border-radius: 12px; background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%); margin: 0; box-shadow: 0 4px 8px rgba(0,0,0,0.15);">
                 <ion-card-content style="text-align: center; color: #fff; padding: 20px 5px; display: flex; flex-direction: column; justify-content: center; height: 100%;">
                  <h2 style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: white;">📝 Teka Teki Silang</h2>
                  <p style="font-size: 11px; margin: 0; line-height: 1.2; color: white;">Tantangan Ilmu Pengetahuan</p>
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>

          <ion-row style="margin-top: 10px;">
            <!-- Game 3: Visual Novel -->
            <ion-col size="6">
              <ion-card @click="goToGame('logika')" style="cursor: pointer; height: 100%; border-radius: 12px; background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); margin: 0; box-shadow: 0 4px 8px rgba(0,0,0,0.15);">
                 <ion-card-content style="text-align: center; color: #fff; padding: 20px 5px; display: flex; flex-direction: column; justify-content: center; height: 100%;">
                  <h2 style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: white;">🕵️‍♂️ Detektif Sains</h2>
                  <p style="font-size: 11px; margin: 0; line-height: 1.2; color: white;">Misteri Cerita Interaktif</p>
                </ion-card-content>
              </ion-card>
            </ion-col>

            <!-- Game 4: Arcade -->
            <ion-col size="6">
              <ion-card @click="goToGame('trivia')" style="cursor: pointer; height: 100%; border-radius: 12px; background: linear-gradient(135deg, #ff0844 0%, #ffb199 100%); margin: 0; box-shadow: 0 4px 8px rgba(0,0,0,0.15);">
                 <ion-card-content style="text-align: center; color: #fff; padding: 20px 5px; display: flex; flex-direction: column; justify-content: center; height: 100%;">
                  <h2 style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: white;">🌟 Tangkap Bintang</h2>
                  <p style="font-size: 11px; margin: 0; line-height: 1.2; color: white;">Arcade Ketangkasan</p>
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-content>
      <ion-grid class="ion-padding">
        <!-- Additional content for the grid can be added here -->
      </ion-grid>

      <!-- jika status nonaktif -->
      <ion-toast
      :is-open="showToast"
      message="Status Anda non-aktif, silakan hubungi admin."
      duration="3000"
      color="danger"
      position="bottom"
      @didDismiss="showToast = false"
    />
    </ion-content>
  </ion-page>
</template>
<script setup>
import {
  IonPage,
  IonContent,
  IonRefresher,
  IonRefresherContent,
  IonGrid,
  IonCard,
  IonLabel,
  IonSpinner,
  IonHeader,
  IonSearchbar,
  IonButton,
  IonBadge,
  IonCol,
  IonRow,
  // IonCardContent,
} from "@ionic/vue";
import { ref, onMounted } from "vue";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import { firebaseApp } from "../views/firebase.js";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useRouter } from "vue-router";
const router = useRouter();

// const navigateToMateri = (materi) => {
//   console.log("Navigating to materi:", materi);
//   if (materi && materi.id && isUserActive.value) { // Hanya jika aktif
//     router.push({
//       name: "lihatmaterimateri",
//       params: { materiId: materi.id },
//     });
//   } else {
//     console.error("Materi atau materiId tidak ditemukan atau user tidak aktif");
//   }
// };

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

// Tambahkan di bagian atas bersama ref lainnya
const medalCount = ref(0);
const ranking = ref(0);
const showToast = ref(false); // Sudah ada di kode Anda

const calculateMedalAndRanking = async (userId) => {
  try {
    // 1. Ambil semua hasil ujian siswa ini
    const resultsRef = collection(db, `examResults/${userId}/results`);
    const resultsSnapshot = await getDocs(resultsRef);
    
    let totalScore = 0;
    // examCount dihapus karena tidak digunakan dalam perhitungan medal
    
    resultsSnapshot.forEach(doc => {
      const data = doc.data();
      totalScore += data.score || 0; // score adalah nilai rata-rata
    });
    
    // 2. Hitung medal (1 medal per 500 poin)
    medalCount.value = Math.floor(totalScore / 10);
    
    // 3. Hitung ranking dengan membandingkan dengan siswa lain
    const allUsersSnapshot = await getDocs(collection(db, "users"));
    const usersData = [];
    
    // Ambil data semua user aktif
    for (const userDoc of allUsersSnapshot.docs) {
      if (userDoc.data().status === "aktif") {
        const userResultsRef = collection(db, `examResults/${userDoc.id}/results`);
        const userResults = await getDocs(userResultsRef);
        
        let userTotalScore = 0;
        let userExamCount = 0; // Tetap digunakan untuk menghitung rata-rata
        
        userResults.forEach(doc => {
          const data = doc.data();
          userTotalScore += data.score || 0;
          userExamCount++;
        });
        
        const averageScore = userExamCount > 0 ? userTotalScore / userExamCount : 0;
        
        usersData.push({
          userId: userDoc.id,
          averageScore,
          fullName: userDoc.data().fullName
        });
      }
    }
    
    // Urutkan dari nilai tertinggi ke terendah
    usersData.sort((a, b) => b.averageScore - a.averageScore);
    
    // Temukan ranking user saat ini
    const currentUserIndex = usersData.findIndex(user => user.userId === userId);
    ranking.value = currentUserIndex + 1; // +1 karena index mulai dari 0
    
  } catch (error) {
    console.error("Error calculating medal and ranking:", error);
    showToast.value = true;
  }
};

const fullName = ref("");
const userClass = ref("");
const mataPelajaran = ref([]);
const loading = ref(true);
const isUserActive = ref(false); // Ref untuk status aktif/non-aktif pengguna
const daftarUjian = ref([]);
const daftarUjiansnbt = ref([]);
const ujianReguler = ref([]);

const navigateToAllUjiansnbt = () => {
  router.push({ name: "SemuaUjianSnbt" });
};

// Ambil ujian reguler dari Firestore
const fetchDaftarUjianReguler = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "jadwal"));
    const allData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // 🔁 Join setiap jadwal ke koleksi 'kelas' untuk ambil nama kelas
    const joinedData = await Promise.all(
      allData.map(async (ujian) => {
        if (ujian.kelas) {
          const kelasDoc = await getDoc(doc(db, "kelas", ujian.kelas));
          if (kelasDoc.exists()) {
            const kelasData = kelasDoc.data();
            ujian.kelasName = kelasData.name || "Tidak diketahui"; // ✅ simpan nama kelas
          } else {
            ujian.kelasName = "Kelas tidak ditemukan";
          }
        }
        return ujian;
      })
    );

    // 📌 Sekarang kamu bisa filter berdasarkan nama kelas
    ujianReguler.value = joinedData.filter(
      (ujian) =>
        ujian.kelasName &&
        ujian.kelasName.trim().toLowerCase() === userClass.value.trim().toLowerCase() &&
        ujian.aktif === true
    );

    console.log("✅ Daftar ujian reguler:", ujianReguler.value);
  } catch (error) {
    console.error("❌ Error fetching ujian reguler:", error);
  }
};


const navigateToDetailUjianReguler = (jadwalId) => {
  if (isUserActive.value) {
    router.push({ name: "ujianreguler", params: { jadwalId } });
  } else {
    console.error("User tidak aktif, menu tidak tersedia");
  }
};

const fetchDaftarUjian = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "jadwalkedinasan"));
    daftarUjian.value = querySnapshot.docs.map((doc) => {
      return {
        id: doc.id,
        ...doc.data(),
      };
    });
    console.log("Daftar ujian fetched:", daftarUjian.value);
  } catch (error) {
    console.error("Error fetching daftar ujian:", error);
  }
};

const fetchDaftarUjiansnbt = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "jadwalsnbt"));
    daftarUjiansnbt.value = querySnapshot.docs.map((doc) => {
      return {
        id: doc.id,
        ...doc.data(),
      };
    });
    console.log("Daftar ujiansnbt fetched:", daftarUjiansnbt.value);
  } catch (error) {
    console.error("Error fetching daftar ujian:", error);
  }
};

const navigateToDetailUjian = (jadwalId) => {
  if (isUserActive.value) { // Hanya jika aktif
    router.push({ name: "ujiankedinasan", params: { jadwalId } });
  } else {
    console.error("User tidak aktif, menu tidak tersedia");
  }
};

const navigateToDetailUjiansnbt = (jadwalId) => {
  if (isUserActive.value) { // Hanya jika aktif
    router.push({ name: "ujiansnbt", params: { jadwalId } });
  } else {
    console.error("User tidak aktif, menu tidak tersedia");
  }
};

const goToRaportPage = () => {
  if (isUserActive.value) { // Hanya jika aktif
    router.push({ name: "raport" }); // Asumsi route name "raport" sudah didefinisikan
  } else {
    console.error("User tidak aktif, menu tidak tersedia");
    // Bisa juga tambahkan notifikasi ke user
    alert("Akun Anda tidak aktif. Silakan aktivasi untuk mengakses raport.");
  }
};

// const goToEbookPage = () => {
//   if (isUserActive.value) { // Hanya jika aktif
//     router.push({ name: "ebook" }); // Asumsi route name "raport" sudah didefinisikan
//   } else {
//     console.error("User tidak aktif, menu tidak tersedia");
//     // Bisa juga tambahkan notifikasi ke user
//     alert("Akun Anda tidak aktif. Silakan aktivasi untuk mengakses raport.");
//   }
// };

// const goToGamesPage = () => {
//   if (isUserActive.value) { // Hanya jika aktif
//     router.push({ name: "games" }); // Asumsi route name "raport" sudah didefinisikan
//   } else {
//     console.error("User tidak aktif, menu tidak tersedia");
//     // Bisa juga tambahkan notifikasi ke user
//     alert("Akun Anda tidak aktif. Silakan aktivasi untuk mengakses raport.");
//   }
// };

const goToGame = (tipe) => {
  // Tetap menampilkan peringatan jika akun tidak aktif
  if (!isUserActive.value) {
    showToast.value = true;
  }
  
  if (tipe === 'dasar') {
    router.push({ name: "gameSederhana", query: { tipe: 'dasar' } });
  } else if (tipe === 'tts') {
    router.push({ name: "gameTts" });
  } else if (tipe === 'logika') {
    router.push({ name: "gameVisualNovel" });
  } else if (tipe === 'trivia') {
    router.push({ name: "gameArcade" });
  }
};

const fetchUserData = async (uid) => {
  try {
    const userDoc = await getDoc(doc(db, "users", uid));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      console.log("User data fetched:", userData);

      fullName.value = userData.fullName;
      isUserActive.value = userData.status === "aktif"; // Set status pengguna

      if (userData.kelas) {
        const classDoc = await getDoc(doc(db, "kelas", userData.kelas));
        if (classDoc.exists()) {
          const classData = classDoc.data();
          userClass.value = classData.name;
        } else {
          userClass.value = "Kelas tidak ditemukan";
          console.error("Class document not found!");
        }
      } else {
        userClass.value = "Tidak ada kelas terdaftar";
        console.log("No class ID in user data");
      }
    } else {
      console.error("User document not found!");
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

const fetchMataPelajaran = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "mataPelajaran"));
    const allData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Semua data mata pelajaran:", allData);

    mataPelajaran.value = allData.filter((item) => {
      console.log(`Membandingkan ${item.kelas} dengan ${userClass.value}`);
      return item.kelas.trim().toLowerCase() === userClass.value.trim().toLowerCase();
    });
    console.log("Mata pelajaran sesuai kelas:", mataPelajaran.value);
  } catch (error) {
    console.error("Error fetching mata pelajaran:", error);
  } finally {
    loading.value = false;
  }
};




onMounted(async () => {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      await fetchUserData(user.uid); // Tunggu pengambilan data user selesai
      await fetchMataPelajaran();   // Baru ambil mata pelajaran
      await fetchDaftarUjian();     // Pastikan urutan benar
      await fetchDaftarUjiansnbt();
      await fetchDaftarUjianReguler(); // <-- tambahkan ini
      await calculateMedalAndRanking(user.uid);
      await calculateMedalAndRanking(user.uid); // Tambahkan ini
    } else {
      console.error("No user is logged in!");
    }
  });
});


const doRefresh = async  (event) => {
  const userId = auth.currentUser?.uid;
  if (userId) {
    fetchUserData(userId);
    fetchMataPelajaran();
  }
  event.target.complete();
};

</script>

<style src="../assets/style/siswa.css"></style>